import { addDays } from "date-fns/addDays";
import { addMonths } from "date-fns/addMonths";
import { startOfMonth } from "date-fns/startOfMonth";

export const getStoreOpeningDateValues = (startDate?: Date) => {
  const newDate = startDate ?? new Date();
  const startingDate =
    newDate.getMonth() !== newDate.getUTCMonth()
      ? addDays(startOfMonth(addDays(newDate, 1)), 1)
      : addDays(startOfMonth(newDate), 1);
  const monthsOptions = [0, 1, 2, 3, 4, 5, 6].map((addAmount) => {
    return addMonths(startingDate, addAmount).getTime();
  });
  return monthsOptions;
};

export const STORE_OPENING_DATE_VALUES = getStoreOpeningDateValues();
